module.exports = __webpack_public_path__ + "appsettings.js";


//////////////////
// WEBPACK FOOTER
// ./~/file-loader?name=[name].[ext]!./configs/appSettings/LOCAL/appsettings.js
// module id = 763
// module chunks = 1